import React, { Component } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';

export default class BuilderCanvas extends Component {
    render() {
        const { fields, selectedFieldId, onSelectField, onRemoveField } = this.props;

        return (
            <div style={{ padding: '10px', minHeight: '400px' }}>
                <h6 style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                    Form Canvas
                    <span className="text-muted" style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '10px' }}>
                        {fields.length} field{fields.length !== 1 ? 's' : ''}
                    </span>
                </h6>
                <Droppable droppableId="canvas">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            style={{
                                minHeight: '300px',
                                border: snapshot.isDraggingOver ? '2px dashed #2196F3' : '2px dashed #ccc',
                                borderRadius: '4px',
                                padding: '8px',
                                backgroundColor: snapshot.isDraggingOver ? '#f0f8ff' : 'transparent'
                            }}
                        >
                            {fields.length === 0 && (
                                <div className="text-center text-muted" style={{ padding: '40px' }}>
                                    <i className="fa fa-arrow-left fa-2x" />
                                    <p className="mt-2">Drag fields from the palette to build your form</p>
                                </div>
                            )}
                            {fields.map((field, index) => (
                                <Draggable key={field.fieldId} draggableId={field.fieldId} index={index}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            onClick={() => onSelectField(field.fieldId)}
                                            style={{
                                                ...provided.draggableProps.style,
                                                padding: '10px 12px',
                                                marginBottom: '4px',
                                                border: selectedFieldId === field.fieldId ? '2px solid #2196F3' : '1px solid #ddd',
                                                borderRadius: '4px',
                                                backgroundColor: snapshot.isDragging ? '#e3f2fd' : (selectedFieldId === field.fieldId ? '#f0f8ff' : '#fff'),
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <div>
                                                <i className="fa fa-grip-vertical" style={{ marginRight: '8px', color: '#999' }} />
                                                <strong>{field.label || field.fieldId}</strong>
                                                <span className="text-muted" style={{ marginLeft: '8px', fontSize: '12px' }}>
                                                    ({field.type})
                                                </span>
                                                {field.validation && field.validation.required && (
                                                    <span className="text-danger" style={{ marginLeft: '4px' }}>*</span>
                                                )}
                                                {field.modelPath && (
                                                    <span className="text-info" style={{ marginLeft: '8px', fontSize: '11px' }}>
                                                        [{field.modelPath}]
                                                    </span>
                                                )}
                                            </div>
                                            <div>
                                                <span style={{ fontSize: '11px', color: '#999', marginRight: '8px' }}>
                                                    col:{field.colSpan || 12}
                                                </span>
                                                <button
                                                    className="btn btn-sm btn-link text-danger"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onRemoveField(field.fieldId);
                                                    }}
                                                    style={{ padding: '0 4px' }}
                                                >
                                                    <i className="fa fa-times" />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
